module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e363"
    }
  }, [_c('div', {
    staticClass: "tx38"
  }, [_c('p', {
    staticClass: "h7",
    staticStyle: {
      "text-align": "right",
      "margin-right": "10%",
      "margin-left": "10%"
    },
    attrs: {
      "id": "d41151131"
    }
  }, [_c('b', [_vm._v("The Gun Seller ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "tx39"
  }, [_c('p', {
    staticClass: "hr",
    attrs: {
      "id": "d41151161"
    }
  }, [_c('b', [_vm._v("Hugh Laurie ")])])]), _vm._v(" "), _c('p', {
    staticClass: "hr",
    staticStyle: {
      "text-align": "right",
      "margin-top": "40%"
    },
    attrs: {
      "id": "d417852"
    }
  }, [_c('img', {
    attrs: {
      "alt": "1114115119",
      "id": "d11141151191",
      "src": "images/9781569470879_opt_0004_001.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a44b56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap4_thegunse_9781569478004_epub_part4.vue
// module id = 60
// module chunks = 0